// extracted by mini-css-extract-plugin
export var growableInput = "_96-0";
export var tagContainer = "_96-2";
export var textInput = "_96-1";